import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '@/tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);

export const getTailwindColor = (name: string) => {
  const colorValue = (fullConfig as any).theme.colors[name];

  if (typeof colorValue === 'object' && !Array.isArray(colorValue)) {
    return colorValue;
  }

  return colorValue;
};
